export const myjarvisLogoUrl = "/logos/logo_jarvis_dark.svg";
